import React from "react";
import { createRoot } from "react-dom/client";
import Routes from './utils/routes';

createRoot(document.getElementById('root')).render(<Routes />);
